<template>
  <div>
    <GoogleMapLoader
      :mapConfig="mapConfig"
      :markers="markers"
      :visible="visible"
      apiKey="AIzaSyDdZOEhCUoz_hd9alpJQXk8Le7IMtNPPx4"
    >
      // insert your google maps api key to render styled map
      <template slot-scope="{ google, map }"></template>
    </GoogleMapLoader>
    <!--<div class="loading" v-if="loading">Loading...</div>-->
    <div class="cp-map--visible">
      <input type="checkbox" id="visible-a" value="A" v-model="visible">
      <label for="visible-a">Autobus</label>
      <input type="checkbox" id="visible-e" value="E" v-model="visible">
      <label for="visible-e">Električka</label>
    </div>
  </div>
</template>

<script>
  import GoogleMapLoader from "./GoogleMapLoader";

  import { mapSettings } from "../constants/mapSettings";

  import TransdataApi from '../services/api/transdata'
  import {config} from '../main.js'

  export default {
    components: {
      GoogleMapLoader
    },

    data() {
      return {
        loading: true,
        markers: {},
        visible: ['A', 'E']
      };
    },

    mounted () {
      this.fetchMarkers()
      setInterval(function () {
        this.fetchMarkers();
      }.bind(this), 2500);
    },

    methods: {
      fetchMarkers: function() {
        this.loading = true
        TransdataApi.getLines()
            .then(lines => {
              this.markers = {}
              for (let key in lines) {
                let line = lines[key]
                let unique_key = line.Line + '_' + line.Trip
                let line_info = config.lines[line.Line]
                let connection = config.connections[line.Line + '_' + line.TripTime]
                if (line_info !== undefined) {
                  let markerData = {
                    id: unique_key,
                    position: {lat: line.Lat, lng: line.Lng},
                    line: line.Line,
                    line_type: line_info.type,
                    trip: line.Trip,
                    dir: line.Dir,
                    delay: line.Delay
                  }
                  if (connection !== undefined) {
                    markerData.from = connection.stop_from
                    markerData.to = connection.stop_to
                  }
                  this.markers[unique_key] = markerData
                }
              }
            })
            .catch(error => console.log(error))
            .finally(() => {
              this.loading = false
            })
      }
    },

    computed: {
      mapConfig() {
        return {
          ...mapSettings,
          center: config.center
        };
      }
    }
  };
</script>



// WEBPACK FOOTER //
// components/CpMap.vue